import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="user--registration"
export default class extends Controller {
  static targets = ['submit']
  static outlets = ['password']

  initialize() {
    if (this.element.tagName !== 'FORM')
      throw new Error(`Expected "form" as the element of "${this.identifier}"`)
  }

  connect() {
    window.submitInvisibleRecaptchaForm = () => {
      this.element.requestSubmit()
    }
  }

  disconnect() {
    delete window.submitInvisibleRecaptchaForm
  }

  submit(event) {
    if (typeof grecaptcha !== 'undefined') {
      event.preventDefault()

      if (this.#validate()) {
        grecaptcha.execute()
      }
    }
  }

  #validate() {
    return (
      typeof this.element.reportValidity !== 'function' ||
      (this.element.reportValidity() && this.passwordOutlet.validate())
    )
  }
}
